import { ArrowRight, Building2, Phone, ShieldCheck, Users } from "lucide-react";

import { Button } from "@/components/ui/button";

export default function LoanCTA({
  badge,
  title,
  description,
  features = [],
  primaryButton,
  secondaryButton,
  onApply,
}) {
  return (
    <section className="relative overflow-hidden bg-primary py-20">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.12),transparent_45%)]" />

      <div className="container relative mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center text-white">
          <span className="inline-flex rounded-full bg-white/10 px-4 py-2 text-sm font-medium">
            {badge}
          </span>

          <h2 className="mt-6 text-4xl font-bold leading-tight md:text-5xl">
            {title}
          </h2>

          <p className="mt-6 text-lg leading-8 text-white/90">{description}</p>

          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {features.map((feature) => {
              const Icon = feature.icon;

              return (
                <div
                  key={feature.title}
                  className="rounded-2xl bg-white/10 p-6 backdrop-blur-sm"
                >
                  <Icon className="mx-auto h-10 w-10" />

                  <h3 className="mt-4 font-semibold">{feature.title}</h3>

                  <p className="mt-2 text-sm text-white/80">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="mt-14 flex flex-col justify-center gap-4 sm:flex-row">
            <Button
              size="lg"
              variant="secondary"
              onClick={onApply}
              className="min-w-[220px]"
            >
              {primaryButton.text}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>

            <Button
              size="lg"
              variant="outline"
              asChild
              className="min-w-[220px] border-white bg-transparent text-white hover:bg-white hover:text-primary"
            >
              <a href={secondaryButton.href}>
                <Phone className="mr-2 h-5 w-5" />
                {secondaryButton.text}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
